import Cookies from 'universal-cookie';
import { AppCookies } from '@enums/cookies';
import Environment from '@config/index';

export const useSiteConfirmation = () => {
  const cookies = new Cookies();

  const hideLangPopup = () => {
    cookies.set(AppCookies.NV_SHOW_LANG_POPIN, false, {
      path: '/',
      domain: Environment.cookieOptions.domain,
    });
  };

  return {
    hideLangPopup,
    shouldHideLangPopup: cookies.get(AppCookies.NV_SHOW_LANG_POPIN) === false,
  };
};
